export const getFailedScriptError = (panoramaClient, e) => {
  const scriptError = new Error('Failed to load installApp API' + (e ? `: ${typeof e === 'string' ? e : JSON.stringify(e)}` : ''));
  panoramaClient == null || panoramaClient.errorMonitor({
    data: {
      environment: 'script'
    }
  }).reportError(scriptError);
  return scriptError;
};
export const SERVERLESS_PREFIX = '/_serverless/app-installer-fed-serverless';
export const INSTALLER_TOPOLOGY_API_URL = `${SERVERLESS_PREFIX}/getInstallerTopology`;
export const APP_STATIC_BUNDLE_FILE = 'app.bundle.min.js';
export const APP_CSS_FILE = 'app.min.css';
export const LOAD_SCRIPT_TRANSACTION = 'load-script';
//# sourceMappingURL=utils.js.map